<template>
  <div class="news">
    <Header :title="title"></Header>
    <van-tabs @change="onTabChange">
      <van-tab v-for="(item, index) in classify"
               :key="index"
               :title="item.name"></van-tab>
    </van-tabs>
    <Empty v-if="!newsList.length"
           :empty_type="{ name: '暂无资讯' }"></Empty>
    <List v-if="showList"
          ref="list"
          url="/api/app/information/index"
          method="post"
          :params="params"
          :on-getdata="onGetdata"
          :showText="newsList.length > 0">
      <ul class="news-content"
          slot="item">
        <router-link tag="li"
                     v-for="(item, index) in newsList"
                     :key="index"
                     :to="{ name: 'NewsDetail', query: { id: item.id } }">
          <img :src="item.thumb_img" />
          <div>
            <p class="name">{{ item.title }}</p>
            <p class="desc">{{ item.description }}</p>
            <div>
              <p class="number">{{ item.click_rate }}</p>
              <p class="time">
                {{ item.created_at | fomartTime("yyyy-MM-dd hh:mm:ss") }}
              </p>
            </div>
          </div>
        </router-link>
      </ul>
    </List>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import List from "@/components/List";
export default {
  name: "news",
  components: {
    Header,
    Empty,
    List
  },
  data () {
    return {
      title: {
        name: "资讯"
      },
      classify: [], // 资讯类别
      newsList: [], // 资讯列表
      params: {
        classify_id: ""
      },
      showList: false // 是否展示列表，在请求到分类之前不展示
    };
  },
  created () {
    this.requestClassify();
  },
  methods: {
    // on event
    onTabChange (index) {
      this.params.classify_id = this.classify[index].id;
      this.$refs.list.reset();
    },
    onGetdata (data) {
      this.newsList = data;
    },
    // request
    requestClassify () {
      this.$http.get("/api/app/information/classify").then(data => {
        this.classify = data;
        this.classify.unshift({
          id: 0,
          name: "全部",
          parent_id: 0
        });
        if (this.classify.length) {
          this.params.classify_id = this.classify[0].id;
        }
        this.showList = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  @extend %default-bg;
  background-color: #fff;
  .news-content {
    padding: 30px;
    li {
      padding: 20px;
      margin-bottom: 30px;
      background: #fff;
      box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.07);
      border-radius: 20px;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        display: block;
        width: 208px;
        height: 129px;
        border-radius: 10px;
        flex: none;
        margin-right: 24px;
      }
      & > div {
        overflow: hidden;
        width: 100%;
        .name {
          @include eps;
          // margin-bottom: 20px;
          font-size: 28px;
          font-weight: 500;
          color: #333;
          line-height: 42px;
          height: 42px;
        }
        .desc {
          @include eps;
          // height: 60px;
          width: 100%;
          font-size: 24px;
          color: #999;
          line-height: 30px;
        }
        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 35px;
          p {
            font-size: 22px;
            color: #999;
            line-height: 22px;
          }
          .number {
            padding: 0 0 0 34px;
            background: url("~@/assets/images/icon-eye.png") left center
              no-repeat;
            background-size: 25px 17px;
          }
          .time {
            padding: 0 0 0 26px;
            background: url("~@/assets/images/icon-time.png") left center
              no-repeat;
            background-size: 17px 17px;
          }
        }
      }
    }
  }
}
</style>
